import { downloadInsuranceCoverageFile } from "../../../services/api/insurance/monitor/downloadInsuranceCoverageFile";
import { useWSMutation } from "@ws-react-query";
import {
  downloadFileFromBlob,
  mimeTypeToExtension
} from "../../../utils/files";

export const useDownloadInsuranceCoverageFile = () => {
  return useWSMutation<
    any,
    unknown,
    { insuranceCoverageMonitorId: string; fileName: string }
  >(async ({ insuranceCoverageMonitorId, fileName }): Promise<void> => {
    const blob = await downloadInsuranceCoverageFile(
      insuranceCoverageMonitorId
    );
    const fileExtension = mimeTypeToExtension(blob.type);

    downloadFileFromBlob(blob, `${fileName}.${fileExtension}`);
  }, {});
};
